(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const headers = document.querySelectorAll(".collection-faq-accordion .collection-accordion-header");
  headers.forEach(header => {
    header.addEventListener("click", function() {
      const item = this.closest(".collection-accordion-item");
      // Only one open at a time
    //   document.querySelectorAll(".collection-accordion-item").forEach(i => {
    //     if (i !== item) i.classList.remove("active");
    //   });
      item.classList.toggle("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"] && !Shopify.designMode) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	}); 
	jQuery(document).ready(function($) {
      $( ".faqs li" ).click(function() {
        $( ".faqs li" ).removeClass("open");
        $( this ).toggleClass( "open" ); 
      });
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const headers = document.querySelectorAll(".product-faq-accordion .product-accordion-header");
  headers.forEach(header => {
    header.addEventListener("click", function() {
      const item = this.closest(".product-accordion-item");
      // Only one open at a time
    //   document.querySelectorAll(".product-accordion-item").forEach(i => {
    //     if (i !== item) i.classList.remove("active");
    //   });
      item.classList.toggle("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
